import Typography, {
  TypographyProps,
  TypographyPropsVariantOverrides,
} from '@mui/material/Typography';
import type { Variant } from '@mui/material/styles/createTypography';
import { useBooleanScreens } from 'shared/hooks/useBooleanScreens';
import React from 'react';

export default function BreadcrumbsItem({
  ...other
}: {
  typographyVariantSize?: keyof TypographyPropsVariantOverrides | Variant;
} & TypographyProps) {
  const { isLessLaptop } = useBooleanScreens();
  return (
    <Typography
      variant={isLessLaptop ? 'f10' : 'f12'}
      sx={{
        display: 'flex',
        alignItems: 'center',
        textDecoration: 'none',
        color: 'inherit',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',

        ...other.sx,
      }}
      {...other}
    ></Typography>
  );
}
